import {
  AccountBalanceChangedPushEvent,
  AccountBalanceChangedExceptionPushEvent,
} from '@rwwa/tabtouch-push-contract'
import { toastIds } from '@mobi/account/Utils/constants'
import { isSelfServePaymentMethod } from '@mobi/component-library/Areas/Deposit/helpers'
import { addToast, removeToast } from '@mobi/component-library/Feedback/Toast'

const FeedbackBalanceChangeSuccess = () =>
  addToast({
    id: toastIds.depositSuccess,
    isDismissable: true,
    title: 'Your balance has been updated.',
    icon: 'success',
  })

const FeedbackWithdrawal = (
  transactionType: AccountBalanceChangedExceptionPushEvent['transactionType']
) => {
  removeToast({ id: toastIds.pendingWithdrawal })

  switch (transactionType) {
    case 'Withdrawal Cancel':
      addToast({
        id: toastIds.withdrawalError,
        isDismissable: true,
        title: 'We have cancelled this withdrawal. Please try again if you wish to withdraw funds.',
        icon: 'error',
        timeoutMs: 6_000, // 6s
      })
      break
  }
}

const FeedbackWithdrawalError = () => {
  removeToast({ id: toastIds.pendingWithdrawal })
  addToast({
    id: toastIds.withdrawalError,
    isDismissable: true,
    title:
      'We were unable to process your withdraw request. You have insufficient funds to withdraw.',
    icon: 'error',
    timeoutMs: 6_000, // 6s
  })
}

const FeedbackDepositError = (exception: AccountBalanceChangedExceptionPushEvent['exception']) => {
  let message = ''
  let title = ''

  switch (exception) {
    case 'DepositPrecommLimit':
      title = 'Daily deposit limit exceeded'
      message =
        'Your deposit exceeded your daily limit. We have refunded the amount. Please try again with a value equal to or lower than your daily limit.'
      break
    case 'DepositMinNotMet':
      title = 'Minimum value not reached'
      message =
        'Your deposit was lower than the minimum deposit value. We have refunded the amount. Please try again.'
      break
    case 'DepositExceptionOthr':
    default:
      title = 'Your deposit could not be completed'
      message =
        'Please try again. If the issue persists, please contact your bank to check your account details or call us on 1300 36 36 88.'
      break
  }

  addToast({
    id: toastIds.depositError,
    isDismissable: true,
    title: title,
    subtitle: message,
    icon: 'error',
    timeoutMs: 6_000, // 6s
  })
}

export const FeedbackBalanceChange = (
  balanceChangeEvent: AccountBalanceChangedPushEvent | AccountBalanceChangedExceptionPushEvent
) => {
  /*
   * We only want to show feedbacks for self serve deposits.
   * The feedback for internal deposits are already handled.
   */
  if (
    balanceChangeEvent.paymentMethod &&
    !isSelfServePaymentMethod(balanceChangeEvent.paymentMethod)
  )
    return

  if ('exception' in balanceChangeEvent) {
    if (
      balanceChangeEvent.exception === 'DepositMinNotMet' ||
      balanceChangeEvent.exception === 'DepositPrecommLimit' ||
      balanceChangeEvent.exception === 'DepositExceptionOthr'
    ) {
      FeedbackDepositError(balanceChangeEvent.exception)
    }

    if (balanceChangeEvent.exception === 'WithdrawInsuffFunds') {
      FeedbackWithdrawalError()
    }
    return
  }

  if (balanceChangeEvent.transactionType?.includes('Withdrawal')) {
    // Delay the feedback to allow the user to see the pending withdrawal toast
    setTimeout(() => FeedbackWithdrawal(balanceChangeEvent.transactionType), 2000)

    return
  }

  FeedbackBalanceChangeSuccess()
}
